import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'

export type ConfirmReturnPickupRequest = {
  returnId: string
  deviceId: string
  pin: string
  qrPayload: string
}

export type ConfirmReturnPickupResponse = {
  picked_up_at: string
}

const MOCK_PIN = '123456'

async function mockConfirmReturnPickup(
  req: ConfirmReturnPickupRequest,
): Promise<ConfirmReturnPickupResponse> {
  if (req.pin !== MOCK_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }
  if (!req.qrPayload.trim()) {
    throw new Error('QR retur tidak valid.')
  }
  await new Promise((r) => setTimeout(r, 500))
  return { picked_up_at: new Date().toISOString() }
}

export async function confirmReturnPickupDirect(
  req: ConfirmReturnPickupRequest,
): Promise<ConfirmReturnPickupResponse> {
  if (shouldUseDelmanMock()) {
    return mockConfirmReturnPickup(req)
  }

  return apiFetch<ConfirmReturnPickupResponse>(
    `/returns/${encodeURIComponent(req.returnId)}/scan-qr`,
    {
      method: 'POST',
      body: JSON.stringify({
        device_id: req.deviceId,
        pin: req.pin,
        qr_payload: req.qrPayload,
      }),
    },
  )
}

export async function confirmReturnPickup(
  req: ConfirmReturnPickupRequest,
): Promise<ConfirmReturnPickupResponse> {
  return runKitchenSync(
    {
      type: 'delman_return_pickup',
      label: `Pickup retur ${req.returnId}`,
      payload: req,
    },
    () => confirmReturnPickupDirect(req),
    () => ({ picked_up_at: new Date().toISOString() }),
  )
}
